import { string } from 'prop-types'
import * as React from 'react'

const propTypes = {
  color: string,
}

function CheckIcon({ color = '#1F2D27', ...props }) {
  return (
    <svg
      width={38}
      height={24}
      viewBox="0 0 38 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M37 1L14.5 23.5 1 10"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

CheckIcon.propTypes = propTypes

export { CheckIcon }
